import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { VALIDATION_FIELD_MAPPING } from '../../../../utils/appConstant';
import Input from '../../../../components/Input';
import Dropdown from '../../../../components/Dropdown';
import { TableContext } from '../../../../contexts/TableContext';
import { RowClassName } from '../../../../enums';

interface RowProps {
  item: any;
  className?: RowClassName;
}

const HeaderMappingRow: React.FC<RowProps> = ({ item, className }) => {
  const { t } = useTranslation();
  const { headCells, rowProps } = useContext(TableContext);

  return (
    <tr className={className}>
      {headCells.map((headCell) => {
        if (headCell.id === VALIDATION_FIELD_MAPPING.actions) {
          return (
            <td key={headCell.id} width={headCell.width} className="text-center align-middle">
              <div className="form-check d-flex justify-content-center m-0">
                <input
                  className="form-check-input mb-0"
                  type="checkbox"
                  checked={!!item.isChecked}
                  onChange={(e) => rowProps?.onCheckChange && rowProps.onCheckChange(item.id, e.target.checked)}
                  id={`checkbox-${item.id}`}
                />
              </div>
            </td>
          );
        }

        if (headCell.id === VALIDATION_FIELD_MAPPING.templateHeader) {
          // Dropdown is always disabled, no search needed
          return (
            <td key={headCell.id} width={headCell.width}>
              <Dropdown
                id={`template-header-${item.id}`}
                name={`template-header-${item.id}`}
                values={item.header ? [item.header] : []}
                options={rowProps?.headerOptions || []}
                allOptions={rowProps?.headerOptions || []}
                label=""
                placeholder={t('templates.addEdit.pageTexts.form.templateHeader.placeholder')}
                onChange={() => { }} // Disabled, so no change handler needed
                disabled={true}
              />
            </td>
          );
        }

        if (headCell.id === VALIDATION_FIELD_MAPPING.textboxMapping) {
          const fieldId = `${VALIDATION_FIELD_MAPPING.textboxMapping}-${item.id}`;
          return (
            <td key={headCell.id} width={headCell.width}>
              <div className="form-floating form-floating-outline">
                <Input
                  id={fieldId}
                  name={fieldId}
                  type="text"
                  value={item.mapping || ''}
                  label={t('templates.addEdit.pageTexts.table.columns.textboxMapping')}
                  placeholder={t('templates.addEdit.pageTexts.form.textboxMapping.placeholder')}
                  error={!!rowProps?.validation?.fields.find((field: any) => field.field === fieldId)}
                  errorMessage={rowProps?.validation?.fields.find((field: any) => field.field === fieldId)?.message ?? ''}
                  onChange={(e) => rowProps?.onInputChange && rowProps.onInputChange(item.id, 'mapping', e.target.value)}
                  onBlur={(e) => rowProps?.onInputBlur && rowProps.onInputBlur(item.id, 'mapping', e.target.value)}
                  disabled={!item.isChecked}
                  required={!!item.isChecked}
                />
              </div>
            </td>
          );
        }

        return null;
      })}
    </tr>
  );
};

export default HeaderMappingRow;

